var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoAiLine = function SvgVideoAiLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.357 7.311-.172.393a.351.351 0 0 1-.648 0l-.171-.393a3.03 3.03 0 0 0-1.541-1.563l-.528-.235a.368.368 0 0 1 0-.668l.498-.222a3.03 3.03 0 0 0 1.563-1.616l.176-.424a.352.352 0 0 1 .654 0l.176.424c.3.725.86 1.303 1.563 1.616l.498.221a.368.368 0 0 1 0 .67l-.528.234a3.03 3.03 0 0 0-1.54 1.563M4.44 3.75h6.254v1.389H5.14v9.722h9.722V9.306h1.389v6.254a.69.69 0 0 1-.69.69H4.44a.69.69 0 0 1-.69-.69V4.44a.69.69 0 0 1 .69-.69m4.603 3.76 3.388 2.259a.278.278 0 0 1 0 .462L9.043 12.49a.278.278 0 0 1-.432-.231V7.74a.278.278 0 0 1 .432-.23"
  })));
};
export default SvgVideoAiLine;